export const INITIAL_PAGE_NUMBER = 1;
export const LIMIT = 20;
export const LIMIT_100 = 100;
export const LIMIT_50 = 50;
